import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  step: PropTypes.string,
};

const defaultProps = {
  id: '',
  required: false,
  onChange: null,
  type: 'number',
  value: '',
  className: '',
  step: '',
};

const NumberInput = props => {
  const node = React.useRef();

  const { name, id, type, placeholder, onChange, required, value, className, step, onBlur } = props;

  React.useEffect(() => {
    if (props.type !== 'number') return;

    const handleWheel = e => {
      e.preventDefault();
      e.stopPropagation();
      node.current?.blur();
    };

    const element = node.current;
    if (element) {
      element.addEventListener('wheel', handleWheel, { passive: false });

      return () => {
        element.removeEventListener('wheel', handleWheel);
      };
    }
  }, [props.type]);

  return (
    <input
      {...props}
      ref={node}
      className={clsx(
        className,
        'appearance-none block w-full py-2 px-2 rounded border-none shadow-input focus:shadow-input-focus',
      )}
      step={step}
      name={name}
      id={id}
      type={type}
      placeholder={placeholder}
      onChange={e => {
        if (onChange) {
          return onChange(e);
        } else {
          return null;
        }
      }}
      required={required}
      value={value}
      onBlur={onBlur}
    />
  );
};

NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;

export default NumberInput;
